var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Searchbar',{staticClass:"tw-col-span-full",attrs:{"simple":"","placeholder":_vm.placeholder,"force-category":_vm.modelValue.defaultCategory,"force-legacy-searchbar":""}})}
var staticRenderFns = []

export { render, staticRenderFns }